var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "defaultHomeGradient",
    x1: 1.50092,
    y1: 9,
    x2: 16.4989,
    y2: 9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#5E5E5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hoverHomeGradient",
    x1: 1.50092,
    y1: 9,
    x2: 16.4989,
    y2: 9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#06BCC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#004CFF"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2476 6.96594L9.00325 1.5L1.75222 6.96594C1.60231 7.10427 1.51218 7.29554 1.50092 7.4992V15.8461C1.50144 16.0188 1.5703 16.1843 1.69244 16.3065C1.81458 16.4286 1.98009 16.4975 2.15283 16.498H6.50025V13.0005C6.50025 12.3375 6.76361 11.7017 7.23238 11.2329C7.70116 10.7642 8.33696 10.5008 8.99992 10.5008C9.66287 10.5008 10.2987 10.7642 10.7674 11.2329C11.2362 11.7017 11.4996 12.3375 11.4996 13.0005V16.5H15.8463C16.0191 16.4995 16.1847 16.4306 16.307 16.3085C16.4292 16.1864 16.4982 16.0209 16.4989 15.8481V7.4992C16.4874 7.29561 16.3973 7.10443 16.2476 6.96594Z",
    stroke: "url(#defaultHomeGradient)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/HomeIcon.1d0e219ba81f1771deeb9af7ce9f652a.svg";
export { ForwardRef as ReactComponent };